var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddCircleIcon = function SvgAddCircleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6668 8.49992C14.6668 12.1818 11.6821 15.1666 8.00016 15.1666C4.31826 15.1666 1.3335 12.1818 1.3335 8.49992C1.3335 4.81802 4.31826 1.83325 8.00016 1.83325C11.6821 1.83325 14.6668 4.81802 14.6668 8.49992ZM2.66667 8.49988C2.66667 11.4454 5.05448 13.8332 8 13.8332C10.9455 13.8332 13.3333 11.4454 13.3333 8.49988C13.3333 5.55436 10.9455 3.16654 8 3.16654C5.05448 3.16654 2.66667 5.55436 2.66667 8.49988Z",
    fill: "#B2B5B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6665 7.83341H10.6665C11.0347 7.83341 11.3332 8.13189 11.3332 8.50008C11.3332 8.86827 11.0347 9.16675 10.6665 9.16675H8.6665V11.1667C8.6665 11.5349 8.36803 11.8334 7.99984 11.8334C7.63165 11.8334 7.33317 11.5349 7.33317 11.1667V9.16675H5.33317C4.96498 9.16675 4.6665 8.86827 4.6665 8.50008C4.6665 8.13189 4.96498 7.83341 5.33317 7.83341H7.33317V5.83341C7.33317 5.46522 7.63165 5.16675 7.99984 5.16675C8.36803 5.16675 8.6665 5.46522 8.6665 5.83341V7.83341Z",
    fill: "#B2B5B2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCircleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-circle-icon.42a49a22.svg";
export { ForwardRef as ReactComponent };